import { useCallback, useEffect } from "react";
import { Spin } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
	FormHeaderComponent,
} from "../../components/styled/common";
import BackComponent from "../../components/BackComponent";
import MainButtonComponent from "../../components/MainButtonComponent";
import VolunteersAboutForm, { applyAboutLocalizableChanges } from "../../components/VolunteersAboutForm";
import { LocalizedContentChanges } from "../../components/LocalizedContentFields";
import { useVolunteersAboutContext } from "../../context/VolunteersAboutContext/VolunteersAboutContext";
import { Culture, VOLUNTEERS_ABOUT_PATH } from "../../context/VolunteersAboutContext/constants";

const AddVolunteersAbout = () => {
	const {
		addVolunteersAbout,
		redirectIfVolunteersAboutExists,
		clearVolunteersAboutFormData,
		volunteersAboutForm,
		setVolunteersAboutForm,
		operationStatus,
	} = useVolunteersAboutContext();

	const isChecking = operationStatus.type === "loading" && operationStatus.operation === "fetch";

	useEffect(() => {
		clearVolunteersAboutFormData();
		redirectIfVolunteersAboutExists();

		return () => {
			clearVolunteersAboutFormData();
		};
	}, [clearVolunteersAboutFormData, redirectIfVolunteersAboutExists]);

	const handleLocalizableChange = useCallback((culture: Culture, changes: LocalizedContentChanges) => {
		setVolunteersAboutForm(prev => ({
			...prev,
			volunteersAboutLocalizable: applyAboutLocalizableChanges(prev.volunteersAboutLocalizable, culture, changes),
		}));
	}, [setVolunteersAboutForm]);

	return (
		<>
			<BackComponent text="Koç Gönüllüleri Hakkında Sayfasına Dön" to={VOLUNTEERS_ABOUT_PATH} />
			<ActionContainer>
				<Spin spinning={isChecking}>
					<ActionItemsContainer>
						<FormHeaderComponent>Koç Gönüllüleri Hakkında Ekleme</FormHeaderComponent>
						<VolunteersAboutForm
							localizables={volunteersAboutForm.volunteersAboutLocalizable}
							isRequired
							onLocalizableChange={handleLocalizableChange}
						/>
						<SubmitButtonOverlay>
							<MainButtonComponent
								onClick={addVolunteersAbout}
								disabled={isChecking}
								loading={operationStatus.type === "loading" && operationStatus.operation === "add"}
							>
								Ekle
							</MainButtonComponent>
						</SubmitButtonOverlay>
					</ActionItemsContainer>
				</Spin>
			</ActionContainer>
		</>
	);
};

export default AddVolunteersAbout;
